/**
 * 信息科路由
 */
const infoManagementRoutes = [
  {
    path: 'hospital-info',
    name: 'hospital-info',
    meta: {
      title: '医院信息维护',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/hospital-info.vue'], resolve)
  },
  {
    path: 'keshiguanli',
    name: 'keshiguanli',
    meta: {
      title: '科室管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/keshiguanli.vue'], resolve)
  },
  {
    path: 'kemu',
    name: 'kemu',
    meta: {
      title: '诊疗科目设置',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/kemu.vue'], resolve)
  },
  {
    path: 'person',
    name: 'person',
    meta: {
      title: '人员管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/person.vue'], resolve)
  },
  {
    path: 'juese',
    name: 'juese',
    meta: {
      title: '角色管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/juese.vue'], resolve)
  },
  {
    path: 'bingqu',
    name: 'bingqu',
    meta: {
      title: '病区管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/bingqu.vue'], resolve)
  },
  {
    path: 'bingchuang',
    name: 'bingchuang',
    meta: {
      title: '病床管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/bingchuang.vue'], resolve)
  },
  {
    path: 'medical-records',
    name: 'medical-records',
    meta: {
      title: '病历查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/info-management/medicalrecords.vue'], resolve)
  },
  {
    path: 'department-reference',
    name: 'department-reference',
    meta: {
      title: '科室医保备案',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/department-reference.vue'], resolve)
  }
]

export default infoManagementRoutes
